import "./index.scss";
import { Link } from "react-router-dom";
import trainImg from "./images/train.gif";
import containerImg from "./images/container.png";
import { Slide } from "react-awesome-reveal";

const SectionJoinUsNow = () => {
  return (
    <div className="section-join-us-now">
      <div className="w3-container" align="center">
        <div className="container">
          <div className="w3-row join">
            <div className="w3-half">
              <div className="join-text">
                <h1 className="title-text">Join the train</h1>
                <p>
                  With tools to make every part of your process more human and a
                  support team always available to help you, we invite you to
                  become one of the schools we are committed to, starting with a
                  FREE account.
                </p>
                <br />
                <Link to="#" className="link-button">
                  Get started for free
                </Link>
              </div>
            </div>
            <div className="w3-half">
              <Slide direction="right">
                <div className="w3-row train-container">
                  <div className="w3-col" style={{ width: "40%" }}>
                    <div className="train-div">
                      <img src={trainImg} alt="train" />
                    </div>
                  </div>
                  <div className="w3-col" style={{ width: "60%" }}>
                    <div className="container-div">
                      <img src={containerImg} alt="train" />
                    </div>
                  </div>
                </div>
              </Slide>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionJoinUsNow;
